import omit from "lodash/omit";
import qs from "qs";
import React, { useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import { useDealerData } from "~/app/Context/DealerContext";
import { Filter, getFilterKeys } from "~/features/filter";
import { useUser } from "~/shared/context/UserContext";

import { violationsFilterFields } from "./fields";

const DEFAULT_DEALER_CANDIDATE = "active";

const ViolationsFilter = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { dealerChoice } = useUser();
  const isDealer = dealerChoice === "one";
  const { DealerId } = useDealerData();

  const fields = useMemo(
    () => violationsFilterFields(t, isDealer),
    [t, isDealer],
  );

  const prevHeaderDealerRef = useRef<string | null>(null);
  useEffect(() => {
    const params = location.search ? qs.parse(location.search.slice(1)) : {};
    const next = { ...params };

    if (!next.dealerCandidate) {
      next.dealerCandidate = DEFAULT_DEALER_CANDIDATE;
    }

    const headerDealerId =
      DealerId || sessionStorage.getItem("currentDealerId");
    if (!isDealer && headerDealerId) {
      const dealerChanged =
        prevHeaderDealerRef.current !== null &&
        prevHeaderDealerRef.current !== headerDealerId;
      if (!next.dealerIdFilter || dealerChanged) {
        next.dealerIdFilter = headerDealerId;
      }
    }
    prevHeaderDealerRef.current = headerDealerId;

    const changed = Object.keys(next).some((key) => next[key] !== params[key]);
    if (!changed) return;
    history.replace({ search: qs.stringify(next) });
  }, [DealerId]);

  // Сброс фильтра также возвращает dealerCandidate = active — так работала
  // отмена в старом фильтре (filterInit с dealerCandidate = active).
  const handleReset = () => {
    const params = location.search ? qs.parse(location.search.slice(1)) : {};
    const rest = omit(params, [...getFilterKeys(fields), "page"]);
    history.replace({
      search: qs.stringify({
        ...rest,
        dealerCandidate: DEFAULT_DEALER_CANDIDATE,
      }),
    });
  };

  // Сетка не должна дробить строки полей: максимальная строка — 7 колонок
  // (вторая строка без учёта дилерских полей), шире — только перенос по newRow.
  return (
    <Filter.Root fields={fields} alwaysShow columns={7} onReset={handleReset} />
  );
};

export default ViolationsFilter;
